import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistributorsComponent } from './distributors.component';
import { DistributorsRoutingModule } from './distributors-routing.module';
import { DistributorService } from './distributors.service';
import { SharedModule } from '../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { GoogleMapsModule, MapCircle } from '@angular/google-maps';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [DistributorsRoutingModule, CommonModule, SharedModule, FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatTabsModule, GoogleMapsModule],
  declarations: [DistributorsComponent],
  exports: [DistributorsComponent],
  providers: [DistributorService]
})
export class DistributorsModule { }
